import { createSlice } from '@reduxjs/toolkit'

import { PROPERTY_TYPES } from '../common/drmTypes'
import { RentVK } from '../common/propertyPriceTypes'
import handleAsyncActions, {
  AsyncState,
  initialFetchState,
  PropertyDataTypes,
} from './fetchAction'

export type SREALITY_LOCALITY_TYPE = 'municipality' | 'ward' | 'district'

export interface LocalitySummary {
  id: number
  name: string
  type: SREALITY_LOCALITY_TYPE
  averagePriceM2: number | null
  transactionsCount: number
}

export interface VkStats {
  dataCoverage: number
  lowerInterval: number
  upperInterval: number
  minimum: number
  maximum: number
  median: number
  reference?: number
  newBuildingAdjustment?: number
}

export interface PriceAttributes {
  unitAreaM2: number | null
  hasElevator: boolean
  isNewBuild: boolean
  isNonPanelOrBrick: boolean

  hasTerrace?: boolean
  hasBalcony?: boolean
  hasGarage?: boolean
  buildingId?: string | number
  constructionCode?: number
  completionDate?: string
}

export interface PriceData {
  propertyId: string
  propertyType: PROPERTY_TYPES
  rentReal: {
    locality: {
      cadastralAreaCode: string
      cadastralAreaName: string
      cityName: string
    }
    vk: Record<RentVK, VkStats>
  }
  saleOffer: {
    dateFrom: string
    dateTo: string
    mainLocality: LocalitySummary
    localities: LocalitySummary[]
  }
  attributes?: PriceAttributes
}

export const propertyPriceSlice = createSlice({
  name: PropertyDataTypes.PRICE,
  initialState: initialFetchState as AsyncState<PriceData>,
  reducers: {},
  extraReducers: builder => {
    handleAsyncActions<PriceData>(builder, PropertyDataTypes.PRICE)
  },
})

export default propertyPriceSlice.reducer
